import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/documents';

const fetchGenericDocuments = createAction('fetchGenericDocuments');
const fetchCustomDocuments = createAction('fetchCustomDocuments');

function fetchGenericDocumentsSuccess(state, action) {
  state.successFetching = true;
  state.errorFetching = false;
  state.document = { ...action.payload };
}

function fetchGenericDocumentsError(state) {
  state.successFetching = false;
  state.errorFetching = true;
  state.document = null;
}
function fetchCustomDocumentsSuccess(state, action) {
  state.successFetching = true;
  state.errorFetching = false;
  state.pdf = action.payload.documento;
}

function fetchCustomDocumentsError(state) {
  state.successFetching = false;
  state.errorFetching = true;
  state.document = null;
}

const documentsReducer = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    fetchGenericDocumentsSuccess,
    fetchGenericDocumentsError,
    fetchCustomDocumentsSuccess,
    fetchCustomDocumentsError,
  },
});

export const documentsActions = {
  ...documentsReducer.actions,
  fetchGenericDocuments,
  fetchCustomDocuments,
};

export default documentsReducer.reducer;
